import { render, staticRenderFns } from "./MentorForm.vue?vue&type=template&id=2115a47e&"
import script from "./MentorForm.vue?vue&type=script&lang=js&"
export * from "./MentorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports